<div #tabList class="tab-list" role="tablist">
  @for (tab of properties; track $index; let index = $index) {
    <button
      type="button"
      class="tab"
      role="tab"
      [id]="'aw-tabs-tab-' + index"
      [tabIndex]="index === selectedTab() ? 0 : -1"
      [style.color]="index === selectedTab() ? getActiveColor() : 'inherit'"
      (click)="selectedTab.set(index)">
      {{ tab.name }}
    </button>
  }
  @if (properties.length) {
    <span
      class="tab-indicator"
      aria-hidden="true"
      [style.width.%]="100 / properties.length"
      [style.transform]="'translateX(' + selectedTab() * 100 + '%)'"
      [style.border-bottom-color]="getActiveColor()"></span>
  }
</div>

@if (properties[selectedTab()]; as tab) {
  <div
    class="tab-panel"
    role="tabpanel"
    tabindex="0"
    [id]="'aw-tabs-panel-' + selectedTab()">
    @if (getContentTemplate(tab.content); as template) {
      <ng-container [ngTemplateOutlet]="template"></ng-container>
    } @else {
      <ng-container>{{ tab.content }}</ng-container>
    }
  </div>
}
